/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gray_Shy_Falcon_LeapInputs */

const en_gray_shy_falcon_leap = /** @type {(inputs: Gray_Shy_Falcon_LeapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Replace existing peer feedback templates`)
};

const de_gray_shy_falcon_leap = /** @type {(inputs: Gray_Shy_Falcon_LeapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorlagen für Peer-Feedback ersetzen`)
};

/**
* | output |
* | --- |
* | "Replace existing peer feedback templates" |
*
* @param {Gray_Shy_Falcon_LeapInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const gray_shy_falcon_leap = /** @type {((inputs?: Gray_Shy_Falcon_LeapInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gray_Shy_Falcon_LeapInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gray_shy_falcon_leap(inputs)
	return de_gray_shy_falcon_leap(inputs)
});